// Add this in a type declaration file (e.g., fabric.d.ts or at the top of your file)
import 'fabric';
import { Canvas, FabricObject } from 'fabric';

declare module 'fabric' {
  interface FabricObject {
    meta?: Record<string, any>;
    name?: string;
  }
  interface ObjectOptions {
    meta?: Record<string, any>;
    name?: string;
  }

  interface Canvas {
    enable_objects_controls(is_enabled: boolean): void;

    enable_objects_movement(is_enabled: boolean): void;
  }
}

Canvas.prototype.enable_objects_controls = function (is_enabled: boolean) {
  this.forEachObject(object => {
    object.setControlsVisibility({
      tl: is_enabled,
      tr: is_enabled,
      bl: is_enabled,
      br: is_enabled,
      ml: is_enabled,
      mt: is_enabled,
      mr: is_enabled,
      mb: is_enabled,
      mtr: is_enabled,
    });
  });

  this.requestRenderAll();
};

Canvas.prototype.enable_objects_movement = function (is_enabled: boolean) {
  // Lock movement when is_enabled is false
  const lock = !is_enabled;

  // Retrieve top-level objects on the canvas
  const objects = this.getObjects();

  objects.forEach((object: FabricObject) => {
    object.set({ lockMovementX: lock, lockMovementY: lock });
  });

  // Re-render canvas to update controls/selection state visually
  this.requestRenderAll();
};

export {}; // Ensure this file is treated as a module
